import { HttpErrorResponse } from '@angular/common/http';
import { ModelError } from '@viewbid/ts-angular-client';

// The API's generated ModelError no longer declares msgForUI, but some
// endpoints still attach it to the error body.
type UIModelError = ModelError & { msgForUI?: string };

// Extract ModelError(as we've defined in the spec) from HttpErrorResponse (what we get when there is an error in the generated code)
export function getViewbidAPIErrorMessageFromBadRequestResponse(
    error: Error,
): string | null {
    if (!(error instanceof HttpErrorResponse)) return null;

    const err: HttpErrorResponse = error as HttpErrorResponse;

    if (err.status != 400) return null;

    if (err.status === 400) {
        const { message } = err.error;

        const patterns: { match: string; uiMessage: string }[] = [
            {
                match: 'user.address.postalCode',
                uiMessage: 'Invalid Postal Code for User Address',
            },
            {
                match: 'organization.address.postalCode',
                uiMessage: 'Invalid Postal Code for Organization Address',
            },
        ];

        const found: { match: string; uiMessage: string } | undefined =
            patterns.find((p: { match: string; uiMessage: string }) =>
                message.includes(p.match),
            );

        if (found) {
            return found.uiMessage;
        }
    }

    if (!err.error['msgForUI']) return null;

    const errorModel: UIModelError = err.error as UIModelError;
    return errorModel.msgForUI ?? '';
}
